module.exports = __webpack_public_path__ + "img/pin-red.55260689.svg";